import { render, staticRenderFns } from "./SingleBusinessPermit.vue?vue&type=template&id=0ee25732&"
import script from "./SingleBusinessPermit.vue?vue&type=script&lang=js&"
export * from "./SingleBusinessPermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports